import { hydrationCompleteEventName } from '../shared/constants';

const waitForNextLoop = async () =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 0);
  });

export const triggerHydrationCompleteEvent = async () => {
  const event = new Event(hydrationCompleteEventName);
  waitForNextLoop().then(() => window.dispatchEvent(event));
};
